/* Keep native variant controls in the theme; hide only while the app provides visible choices. */
(() => {
  const marker = 'data-strive-bundle-variant-picker';
  const bound = new WeakSet();
  const style = document.createElement('style');
  style.textContent = `[${marker}] variant-selects { display: none !important; }`;
  document.head.append(style);
  const visible = element => element.getClientRects().length > 0 &&
    (typeof element.checkVisibility !== 'function' || element.checkVisibility({visibilityProperty: true}));
  function refresh(section) {
    const hasPicker = [...section.querySelectorAll('section-store--bundle-block')].some(bundle =>
      visible(bundle) && [...(bundle.shadowRoot?.querySelectorAll(
        'section-store--product-option-picker, section-store--product-variant-selector, select'
      ) || [])].some(visible)
    );
    section.toggleAttribute(marker, hasPicker);
  }
  function bind() {
    document.querySelectorAll('section-store--bundle-block').forEach(bundle => {
      const section = bundle.closest('product-info, [id^="MainProduct-"]');
      if (!section || !bundle.shadowRoot || bound.has(bundle)) return;
      bound.add(bundle);
      let frame;
      const schedule = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => refresh(section));
      };
      new MutationObserver(schedule).observe(bundle.shadowRoot, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['class', 'style', 'hidden']
      });
      new ResizeObserver(schedule).observe(bundle);
      bundle.addEventListener('change', schedule);
      schedule();
    });
    document.querySelectorAll(`[${marker}]`).forEach(refresh);
  }
  customElements.whenDefined('section-store--bundle-block').then(bind);
  new MutationObserver(bind).observe(document.body, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', bind);
})();
